import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUser = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "currentColor",
	viewBox: "6.2 5.2 19.6 22.2",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.904 10.792c0-2.224 1.826-4.042 4.096-4.042s4.096 1.818 4.096 4.042c0 2.224-1.826 4.041-4.096 4.041s-4.096-1.817-4.096-4.041ZM16 5.25c-3.083 0-5.596 2.473-5.596 5.542 0 3.068 2.513 5.541 5.596 5.541s5.596-2.473 5.596-5.541c0-3.069-2.513-5.542-5.596-5.542Zm-5.837 15.527A8.302 8.302 0 0 1 16 18.387c2.19 0 4.29.86 5.837 2.39a8.098 8.098 0 0 1 2.413 5.759.75.75 0 0 0 1.5 0 9.598 9.598 0 0 0-2.859-6.826A9.802 9.802 0 0 0 16 16.887a9.802 9.802 0 0 0-6.891 2.823 9.598 9.598 0 0 0-2.859 6.826.75.75 0 0 0 1.5 0c0-2.159.867-4.23 2.413-5.76Z",
		fill: "currentColor"
	})
});
export { SvgUser as ReactComponent };
